import { Recording } from '../types';

const DB_NAME = 'kinetic_harmony_db';
const STORE_NAME = 'recordings';
const DB_VERSION = 1;

export const storageService = {
  async initDB(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);
      
      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
      
      request.onupgradeneeded = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME, { keyPath: 'id' });
        }
      };
    });
  },

  async saveRecording(recording: Recording): Promise<void> {
    const db = await this.initDB();
    // We do NOT store the URL because blob URLs are revoked on page refresh.
    // We only store the blob and metadata.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { url, ...dataToStore } = recording;
    
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], 'readwrite');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.put(dataToStore);
      
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  },

  async getAllRecordings(): Promise<Recording[]> {
    const db = await this.initDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], 'readonly');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.getAll();
      
      request.onsuccess = () => {
        const items = request.result;
        // Re-create Blob URLs from the stored Blobs
        const hydratedItems = items.map((item: any) => ({
          ...item,
          url: URL.createObjectURL(item.blob)
        }));
        
        // Sort by newest first
        hydratedItems.sort((a: Recording, b: Recording) => b.timestamp - a.timestamp);
        resolve(hydratedItems);
      };
      
      request.onerror = () => reject(request.error);
    });
  },

  async deleteRecording(id: string): Promise<void> {
    const db = await this.initDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], 'readwrite');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.delete(id);
      
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  }
};